// 콜백 state — 외부 인증창(Toss 등) 리다이렉트가 us-내부 컨텍스트를 보존하기 위한 계약.
// producer(결제 진입 feature)가 successUrl/failUrl 의 `?state=` 에 인코딩해 싣고,
// consumer(콜백 페이지)가 디코딩해 분기·복귀 경로 결정. `type` 으로 연동 종류를 판별한다.
// 인/디코딩은 범용 `url-state` 코덱 위에 타입 가드만 얹는다.
import { decodeUrlState, encodeUrlState } from '../url-state';

/** Toss 카드 등록 콜백 컨텍스트. */
export interface TossCallbackState {
  type: 'toss';
  /** 처리 완료/실패 후 돌아갈 풀 URL(결제 진입 시점 `window.location.href`, 자기 origin). */
  redirectUrl: string;
}

/** 콜백 state union — `type` 판별자. 다른 연동이 콜백을 공유하면 여기에 확장. */
export type CallbackState = TossCallbackState;

/** state → URL-safe 문자열(`?state=` 직삽 가능). */
export function encodeCallbackState(state: CallbackState): string {
  return encodeUrlState(state);
}

/** URL-safe 문자열 → state. 깨진 값·알 수 없는 `type` 은 `null`(호출처가 폴백 처리). */
export function decodeCallbackState(raw: string | null): CallbackState | null {
  const state = decodeUrlState<CallbackState>(raw);
  return state?.type === 'toss' ? state : null;
}
